/** Accident Atlas chart palette (design reference) */
export const ACCIDENT_ATLAS_CHART_COLORS = [
  '#98D8D8', // teal
  '#C0D830', // lime
  '#FF8C70', // coral
  '#2D2D2D', // charcoal
] as const

const ACCIDENT_ATLAS_ALTERNATING_COLOR_COUNT = 3

export function getChartColor(index: number): string {
  return ACCIDENT_ATLAS_CHART_COLORS[index % ACCIDENT_ATLAS_CHART_COLORS.length]
}

/** Blue / green / orange cycle for categorical bars and pie slices */
export function getAlternatingChartColor(index: number): string {
  return ACCIDENT_ATLAS_CHART_COLORS[
    index % ACCIDENT_ATLAS_ALTERNATING_COLOR_COUNT
  ]
}

const SERIES_LINE_DASH_PATTERNS: number[][] = [[], [6, 4], [2, 2], [8, 4, 2, 4]]

const SERIES_POINT_STYLES = ['circle', 'rect', 'triangle', 'rectRot'] as const

/** Distinct dash patterns for multi-series line charts */
export function getSeriesLineDash(seriesIndex: number): number[] {
  return SERIES_LINE_DASH_PATTERNS[
    seriesIndex % SERIES_LINE_DASH_PATTERNS.length
  ]
}

/** Distinct legend / point shapes for multi-series line charts */
export function getSeriesPointStyle(
  seriesIndex: number
): typeof SERIES_POINT_STYLES[number] {
  return SERIES_POINT_STYLES[seriesIndex % SERIES_POINT_STYLES.length]
}
